import { gql } from "lib/apolloClient";

export const workbookTemplateFragment = {
  organizationResourceBasicDetailsItem: gql`
    fragment organizationResourceBasicDetailsItem on OrganizationResource {
      id
      label
      type
      resourceType
      state
      attachment {
        ...attachmentFragment
      }
      childrenV2(
        first: $first
        after: $after
        filters: {
          types: $types
          searchText: $searchText
          states: $states
          status: $status
          courseIds: $courseIds
          createdBy: $createdBy
        }
      ) {
        resourceTypeBasedCount {
          totalCount
        }
        pageInfo {
          hasNextPage
          endCursor
        }
        edges {
          node {
            id
            ... on OrganizationResource {
              id
              label
              type
              resourceType
              status
              state
              attachment {
                ...attachmentFragment
              }
              createdBy {
                id
                firstName
                middleName
                lastName
              }
            }
          }
        }
      }
    }
  `,
  attachmentFragment: gql`
    fragment attachmentFragment on Attachment {
      id
      type
      url
      signedUrl
      name
      thumbUrl
      metadata
    }
  `,
};

export const attachmentFragment = {
  attachment: gql`
    fragment attachmentItem on Attachment {
      id
      name
      type
      mimeType
      url
      signedUrl
      thumbUrl
      title
      metadata
      streamUrl
      parentType
      presetAttachment {
        id
      }
      createdBy {
        id
        type
      }
    }
  `,
  basicDetails: gql`
    fragment attachmentBasicDetailsItem on Attachment {
      id
      url
      signedUrl
      thumbUrl
      metadata
      name
      type
    }
  `,
};
